import type { UseCase } from './enums';

interface ExperimentTag {
  num: number;
  id: string;
  variant: string;
}

export type Experiments = ExperimentTag[];

export const featuresKey = {
  newPaymentsView: 'anzApacUiFeature',
  deleteSavedCreditCard: 'deleteSavedCCFeature',
  invoiceSavedCCFeature: 'invoiceSavedCCFeature',
  disablePaymentRedirectForUpgrade: 'disablePaymentRedirectForUpgrade',
  showIDOnlineBanking: 'showIDOnlineBanking',
  showHKFps: 'showHKFps',
  aaTest: 'aaTest',
  aaTestBNPL: 'aaTestBNPL',
  showPaymentRedirectForUpgrade: 'showPaymentRedirectForUpgrade',
  showPaymentRedirectForAdBudget: 'showPaymentRedirectForAdBudget',
  showPHBnpl: 'showPHBnpl',
  showPHPaymaya: 'showPHPaymaya',
};

export const getExperimentsFromFeatures = (
  features: string[],
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  useCase: UseCase,
): ExperimentTag[] => {
  // Experiments context data - https://myseek.atlassian.net/wiki/spaces/SAA/pages/2471919748/Stored+Credit+Card+Tracking+PaMI
  const contextData = {
    hideHKFps: {
      num: 7,
      id: 'payment_widget_fps_paymentmethod',
      variant: '0',
    },
    showHKFps: {
      num: 7,
      id: 'payment_widget_fps_paymentmethod',
      variant: '1',
    },
    hidePHBnpl: {
      num: 6,
      id: 'payment_widget_bnpl_paymentmethod',
      variant: '0',
    },
    showPHBnpl: {
      num: 6,
      id: 'payment_widget_bnpl_paymentmethod',
      variant: '1',
    },
  };
  const experiment: Experiments = [];
  if (features.includes(featuresKey.aaTest)) {
    experiment.push(contextData.showHKFps);
  } else {
    experiment.push(contextData.hideHKFps);
  }

  if (features.includes(featuresKey.aaTestBNPL)) {
    experiment.push(contextData.showPHBnpl);
  } else {
    experiment.push(contextData.hidePHBnpl);
  }

  return experiment;
};
